// angular
import { Component, OnInit, Input } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss'],
})

export class BarChartComponent implements OnInit {
  @Input() title: string = '';
  @Input() subTitle: string = '';
  @Input() color: string = '';
  @Input() xAxisData: Array<any> = [];
  @Input() xAxisType: 'value' | 'category' | 'time' | 'log' = 'category';
  @Input() yAxisType: 'value' | 'category' | 'time' | 'log' = 'value';
  @Input() seriesData: Array<any> = [];
  @Input() showLeyend?: boolean = true;

  customOptions: any = {};
  chartOptions: EChartsOption = {};

  constructor() {}

  ngOnInit() {
    this.customOptions = {
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        show: this.showLeyend,
        data: this.seriesData.map(({name}) => name)
      },
      xAxis: {
        type: this.xAxisType,
        data: this.xAxisData,
      },
      yAxis: {
        type: this.yAxisType,
      },
      // example of series object
      /* {
        name: 'bar1',
        data: [820, 932, 901, 934, 1290, 1330, 1320],
        type: 'bar',
        emphasis: {
          focus: 'series'
        },
      }, */
      series: this.seriesData
    };

    if (!!this.title) this.customOptions.title = { text: this.title };
    if (!!this.title && !!this.subTitle) this.customOptions.title = {
      text: this.title,
      subtext: this.subTitle
    };
    if (this.color) this.customOptions.color = this.color;

    this.chartOptions = this.customOptions;
  }
}
